export default "__VITE_ASSET__naHChkSt__"